<div class="n-oldalfej">
  <div>
    <h2>Adatok rögzítése – egyszerűsített foglalkoztatás (EFO)</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · alkalmi munka, idénymunka, filmipari statiszta</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="navLista()" [disabled]="navFut || !aktiv.ugyfelId"
              title="A NAV-nál nyilvántartott EFO-napok lekérdezése (M2M) – a más munkáltatónál ledolgozott napokkal együtt">
    <ion-icon slot="start" name="cloud-download-outline"></ion-icon>{{ navFut ? 'NAV-lekérdezés…' : 'NAV-napok lekérdezése' }}
  </ion-button>
  <ion-button fill="outline" style="--color:#fff;--border-color:rgba(255,255,255,.6)" (click)="bejelentes()" [disabled]="bejelentFut || !aktiv.ugyfelId"
              title="A rögzített napok bejelentése a NAV-hoz (T1042E) – a kitöltőben ellenőrizhető és beküldhető">
    <ion-icon slot="start" name="paper-plane-outline"></ion-icon>{{ bejelentFut ? 'Előkészítés…' : 'Bejelentés (T1042E)' }}
  </ion-button>
  <ion-button (click)="uj()" [disabled]="!d"><ion-icon slot="start" name="person-add-outline"></ion-icon>Napok rögzítése</ion-button>
</div>

<!-- A NAV-nál nyilvántartott EFO-napok (M2M). A más munkáltatónál ledolgozott napokat is tartalmazza. -->
<div class="tabla-wrap" *ngIf="navSorok">
  <table class="n-racs">
    <thead>
      <tr><th colspan="9">A NAV nyilvántartása – {{ aktiv.ev }}. év
        <span class="cimke" [class.sarga]="navKornyezet === 'teszt'">{{ navKornyezet === 'teszt' ? 'tesztkörnyezet' : 'éles' }}</span></th></tr>
      <tr><th>Munkavállaló</th><th>Adóazonosító</th>
        <th class="num" *ngFor="let j of navJelleg">{{ j.cim }} (felhasznált / marad)</th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of navSorok">
        <td><b>{{ r.nev }}</b></td><td>{{ r.adoazonosito || '—' }}</td>
        <td class="num" *ngFor="let j of navJelleg">
          {{ r.felhasznalt[j.k] }} / <b [class.cs-neg]="!r.felhasznalhato[j.k]">{{ r.felhasznalhato[j.k] }}</b>
        </td>
      </tr>
      <tr *ngIf="!navSorok.length"><td colspan="6" class="halvany">A NAV nem tart nyilván EFO-napot erre az évre.</td></tr>
    </tbody>
  </table>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<ng-container *ngIf="aktiv.ugyfelId && d">
  <div class="n-szuro-sor">
    <span class="cimke" title="Napi közteher munkavállalónként (a minimálbér %-a, száz forintra kerekítve)">Alkalmi {{ ft(d.napi_kozteher.alkalmi) }} Ft/nap</span>
    <span class="cimke">Mg. idénymunka {{ ft(d.napi_kozteher.idenymunka_mg) }} ({{ param.efo_mg_alap }}. nap után {{ ft(d.napi_kozteher.mg2) }})</span>
    <span class="cimke">Tur. idénymunka {{ ft(d.napi_kozteher.idenymunka_turisztikai) }}</span>
    <span class="cimke">Statiszta {{ ft(d.napi_kozteher.filmipari_statiszta) }}</span>
    <div class="spacer"></div>
    <button type="button" class="ov-gomb" (click)="nyomtatOsszesito()" [disabled]="!d.sorok.length"><ion-icon name="print-outline"></ion-icon>Összesítő</button>
    <button type="button" class="ov-gomb" (click)="nyomtatNapok()" [disabled]="!d.sorok.length"><ion-icon name="print-outline"></ion-icon>Napok</button>
    <button type="button" class="ov-gomb" (click)="csvBejelentes()" [disabled]="!d.bejelentesek.length" title="A NAV-bejelentéshez szükséges adatok időszakonként">
      <ion-icon name="download-outline"></ion-icon>CSV a bejelentéshez</button>
    <button type="button" class="ov-gomb" (click)="parameterek()"><ion-icon name="options-outline"></ion-icon>Paraméterek</button>
  </div>

  <div class="ata-kpi">
    <div class="n-panel ata-k"><span>EFO-napok</span><b>{{ d.osszesen.napok }}</b><small>{{ d.dolgozok.length }} munkavállaló · {{ idoszak }}</small></div>
    <div class="n-panel ata-k"><span>Kifizetett bér</span><b>{{ ft(d.osszesen.ber) }} Ft</b><small>levonás nélkül (nincs járulék, SZJA-előleg)</small></div>
    <div class="n-panel ata-k ata-teher"><span>Közteher</span><b>{{ ft(d.osszesen.kozteher) }} Ft</b><small>esedékes: {{ esedekes }}</small></div>
    <div class="n-panel ata-k"><span>Alkalmi létszámkeret ({{ aktiv.ev }})</span><b>{{ d.letszamkeret.felhasznalt }} / {{ d.letszamkeret.eves }}</b>
      <div class="ata-sav"><i [style.width.%]="d.letszamkeret.eves ? (d.letszamkeret.felhasznalt / d.letszamkeret.eves * 100 > 100 ? 100 : d.letszamkeret.felhasznalt / d.letszamkeret.eves * 100) : 0"
        [class.veszely]="d.letszamkeret.felhasznalt > d.letszamkeret.eves"></i></div>
      <small>fő·nap · napi keret {{ d.letszamkeret.keret_1 }} / {{ d.letszamkeret.keret_2 }} fő (I./II. félév)</small></div>
  </div>

  <!-- figyelmeztetések -->
  <div class="n-panel efo-figy" *ngIf="d.figyelmeztetesek.length">
    <div class="n-panel-cim">Figyelmeztetések ({{ d.figyelmeztetesek.length }})
      <span class="cimke efo-hiba-cimke" *ngIf="hibak.length">{{ hibak.length }} korlát-túllépés</span></div>
    <div class="efo-figy-sor" *ngFor="let f of d.figyelmeztetesek" [ngClass]="f.szint">
      <ion-icon [name]="szintIkon(f.szint)"></ion-icon>
      <span><b *ngIf="f.szemely">{{ f.szemely }}: </b>{{ f.szoveg }}</span>
    </div>
    <p class="halvany efo-sugo">A figyelmeztetés nem tilt. A korlát túllépésével létesített munkaviszonyra az egyszerűsített foglalkoztatás
      kedvező szabályai nem alkalmazhatók (NAV 46. füzet 3. pont). A munkavállaló más foglalkoztatónál töltött napjait a program nem látja.</p>
  </div>

  <div class="ures" *ngIf="!d.sorok.length"><ion-icon name="person-add-outline"></ion-icon>{{ idoszak }}: nincs rögzített EFO-nap.</div>

  <!-- munkavállalónként -->
  <div class="tabla-wrap" *ngIf="d.dolgozok.length">
    <table class="n-racs">
      <thead><tr>
        <th>Munkavállaló</th><th>Adóazonosító</th><th>TAJ</th><th>Jelleg (napok)</th>
        <th class="num">Napok</th><th class="num">Bér</th><th class="num cs-penz">Közteher</th>
        <th class="num cs-afa" title="Az évben ennél a foglalkoztatónál">Éves napok</th>
        <th class="num cs-afa" title="Az éves EFO-bevétel és a mentesített keretösszeg (a napibér 130%-a × napok)">Éves bevétel / mentes keret</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let w of d.dolgozok">
          <td><b>{{ w.nev }}</b> <span class="cimke" *ngIf="!w.alkalmazott_id" title="Nem szerepel az alkalmazotti törzsben">alkalmi</span></td>
          <td>{{ w.adoazonosito || '—' }}</td><td>{{ w.taj || '—' }}</td>
          <td class="halvany">{{ tipusSzoveg(w.tipusok) }}</td>
          <td class="num">{{ w.napok }}</td><td class="num">{{ ft(w.ber) }}</td><td class="num cs-penz">{{ ft(w.kozteher) }}</td>
          <td class="num cs-afa">{{ w.ev_napok }}</td>
          <td class="num cs-afa" [class.efo-tul]="w.ev_bevetel > w.ev_mentes">{{ ft(w.ev_bevetel) }} / {{ ft(w.ev_mentes) }}</td>
        </tr>
      </tbody>
      <tfoot><tr>
        <td colspan="4">Összesen</td><td class="num">{{ d.osszesen.napok }}</td><td class="num">{{ ft(d.osszesen.ber) }}</td>
        <td class="num cs-penz">{{ ft(d.osszesen.kozteher) }}</td><td class="cs-afa"></td><td class="cs-afa"></td>
      </tr></tfoot>
    </table>
  </div>

  <!-- éves nézetben havonta -->
  <div class="tabla-wrap" *ngIf="!ho">
    <table class="n-racs">
      <thead><tr><th>Hónap</th><th class="num">Napok</th><th class="num">Bér</th><th class="num cs-penz">Közteher</th><th>Esedékes</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of d.havonta" [class.efo-ures]="!h.napok">
          <td><b>{{ honapNev(h.ho) }}</b></td><td class="num">{{ h.napok || '' }}</td><td class="num">{{ h.napok ? ft(h.ber) : '' }}</td>
          <td class="num cs-penz">{{ h.napok ? ft(h.kozteher) : '' }}</td>
          <td class="halvany">{{ h.napok ? esedekesHo(h.ho) : '' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- napok -->
  <div class="tabla-wrap" *ngIf="d.sorok.length">
    <table class="n-racs">
      <thead><tr>
        <th>Dátum</th><th>Munkavállaló</th><th>Jelleg</th><th class="num">Óra</th><th class="num">Napi bér</th>
        <th class="num cs-penz">Közteher</th><th>Megjegyzés</th><th></th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let s of d.sorok" (dblclick)="modosit(s)">
          <td>{{ s.datum }}</td>
          <td>{{ s.nev }}</td>
          <td>{{ tipusCim(s.tipus) }}<span class="halvany" *ngIf="s.mg_nap"> · {{ s.mg_nap }}. nap</span>
            <span class="cimke" *ngIf="s.szakkepzett" title="Szakképzettséget igénylő munkakör (garantált bérminimum)">szakk.</span></td>
          <td class="num">{{ s.orak }}</td>
          <td class="num" [class.efo-tul]="s.figyelem?.length">{{ ft(s.napi_ber) }}
            <ion-icon *ngIf="s.figyelem?.length" name="warning-outline" class="efo-jel" [title]="s.figyelem.join(' ')"></ion-icon></td>
          <td class="num cs-penz">{{ ft(s.kozteher) }}</td>
          <td class="halvany"><div class="n-ket-sor" [title]="s.megjegyzes || ''">{{ s.megjegyzes }}</div></td>
          <td class="ber-muv">
            <button type="button" class="kv-mini" (click)="modosit(s)" title="Módosítás"><ion-icon name="create-outline"></ion-icon></button>
            <button type="button" class="kv-torol" (click)="torol(s)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- bejelentési lista -->
  <div class="n-panel" *ngIf="d.bejelentesek.length">
    <div class="n-panel-cim">A NAV-bejelentéshez – {{ idoszak }}</div>
    <p class="halvany efo-sugo">
      A bejelentést <b>a munkavégzés megkezdése előtt</b> kell megtenni a NAV-nál. Innen a fejléc <b>Bejelentés (T1042E)</b> gombja
      a rögzített napokból kitöltött T1042E adatlapot nyitja meg a nyomtatványkitöltőben: ott ellenőrizhető, és gépi úton (M2M) beküldhető –
      abba a környezetbe (teszt/éles), amelyik a NAV-kapcsolatnál használatban van. Más út: ONYA (az onnan letöltött XML betöltésével),
      EFO / EFO pro mobilalkalmazás vagy telefon. Az alábbi lista és a CSV a bejelentés adatait gyűjti össze (Efo tv. 11. §): név,
      adóazonosító jel, TAJ-szám, a foglalkoztatás jellege, a napok száma.
    </p>
    <div class="tabla-wrap jt-belso">
      <table class="n-racs">
        <thead><tr><th>Munkavállaló</th><th>Adóazonosító</th><th>TAJ</th><th>Jelleg</th><th>Első nap</th><th>Utolsó nap</th><th class="num">Napok</th></tr></thead>
        <tbody>
          <tr *ngFor="let b of d.bejelentesek">
            <td>{{ b.nev }}</td><td>{{ b.adoazonosito || '—' }}</td><td [class.efo-tul]="!b.taj">{{ b.taj || 'hiányzik' }}</td>
            <td>{{ b.tipus_cim }}</td><td>{{ b.kezdo }}</td><td>{{ b.zaro }}</td><td class="num">{{ b.napok }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- létszám -->
  <div class="n-panel efo-letszam">
    <div class="n-panel-cim">Alkalmi létszámkeret – {{ aktiv.ev }}</div>
    <p class="halvany efo-sugo">
      Alkalmi munkára naponta legfeljebb: főállású munkavállaló nélkül {{ param.efo_letszam_0 }} fő, 1–5 fő mellett {{ param.efo_letszam_5 }} fő,
      6–20 fő mellett {{ param.efo_letszam_20 }} fő, afölött a létszám {{ szazalek(param.efo_letszam_hanyad) }}%-a (Efo tv. 1. § (2)). A napi keret az év
      napjaira egyenlőtlenül is beosztható. Az alap az átlagos statisztikai létszám a tárgyév első, illetve hetedik hónapját megelőző hat hónapban.
      <ng-container *ngIf="!d.letszam.megadott"> Még nincs megadva – a törzs aktív munkaviszonyaiból becsülve: <b>{{ d.letszam.becsles }} fő</b>.</ng-container>
    </p>
    <div class="efo-letszam-mezok">
      <label class="kv-mezo"><span>I. félév (fő)</span><input type="number" min="0" step="0.01" [(ngModel)]="letszam.letszam_1"></label>
      <label class="kv-mezo"><span>II. félév (fő)</span><input type="number" min="0" step="0.01" [(ngModel)]="letszam.letszam_2"></label>
      <button type="button" class="ov-gomb" (click)="letszamMent()"><ion-icon name="save-outline"></ion-icon>Mentés</button>
    </div>
  </div>

  <div class="n-panel ata-info jt-info">
    <div class="n-panel-cim">Szabályok (2026)</div>
    <ul>
      <li><b>Közteher</b> munkavállalónként, a munkaviszony minden napjára, a hónap első napján érvényes minimálbér
        {{ szazalek(param.efo_kozteher_alkalmi) }}%-a (alkalmi), {{ szazalek(param.efo_kozteher_mg) }}%-a (mezőgazdasági idénymunka, a {{ param.efo_mg_alap }}. nap után
        {{ szazalek(param.efo_kozteher_mg2) }}%), {{ szazalek(param.efo_kozteher_tur) }}%-a (turisztikai), {{ szazalek(param.efo_kozteher_film) }}%-a (filmipari statiszta),
        száz forintra kerekítve (Efo tv. 8. § (2)). A tárgyhónapot követő hónap 12-éig fizetendő.</li>
      <li>A közteher kiváltja a szochót, a munkavállaló járulékát és az SZJA-előleget. <b>SZJA-mentes</b> (mentesített keretösszeg) a napok × a napibér
        130%-a: {{ ft(d.mentes_napi.min) }} Ft/nap, szakképzettséget igénylő munkakörben {{ ft(d.mentes_napi.gar) }} Ft/nap; a felette levő részt a munkavállaló vallja be.
        A statiszta jövedelme nem vallandó be.</li>
      <li><b>Alkalmi munka</b> ugyanazon felek között legfeljebb {{ param.efo_alkalmi_egymas_utan }} egymást követő napig, egy hónapban {{ param.efo_alkalmi_havi }} napig.
        Az EFO-napok együtt évente legfeljebb {{ param.efo_ev_max }} napig; mezőgazdasági idénymunka legfeljebb {{ param.efo_mg_max }} napig (Efo tv. 1. § (4)–(4a), 2. § 3.).</li>
      <li><b>Legkisebb bér</b>: a minimálbér {{ szazalek(param.efo_ber_min_hanyad) }}%-a, szakképzettséget igénylő munkakörben a garantált bérminimum
        {{ szazalek(param.efo_ber_gar_hanyad) }}%-a (Efo tv. 4. § (1a)). Filmipari statiszta napi nettó jövedelme legfeljebb {{ ft(d.film_hatar) }} Ft.</li>
      <li *ngIf="d.kivas">KIVA-alanynál is az EFO-közterhet kell fizetni (az EFO-bér nem járulékalap, ezért a KIVA alapjába sem tartozik – ellenőrizendő).</li>
    </ul>
  </div>
</ng-container>

<!-- ═══════════════ napok rögzítése ═══════════════ -->
<ion-modal #rogModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>EFO-napok rögzítése</ion-title>
      <ion-buttons slot="end"><ion-button (click)="rogModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="rog">
        <div class="nk-kapcs">
          <label><input type="radio" name="efoForras" value="torzs" [(ngModel)]="rog.forras" [disabled]="!alkalmazottak.length"> Az alkalmazotti törzsből</label>
          <label><input type="radio" name="efoForras" value="kulso" [(ngModel)]="rog.forras"> Törzsön kívüli (alkalmi) munkavállaló</label>
        </div>
        <label class="kv-mezo" *ngIf="rog.forras === 'torzs'"><span>Munkavállaló *</span>
          <select [(ngModel)]="rog.alkalmazott_id"><option [ngValue]="null">– válassz –</option>
            <option *ngFor="let a of alkalmazottak" [ngValue]="a.id">{{ a.nev }}{{ a.adoazonosito ? ' · ' + a.adoazonosito : '' }}</option></select></label>
        <ng-container *ngIf="rog.forras === 'kulso'">
          <label class="kv-mezo" *ngIf="korabbiKulsok.length"><span>Korábbi munkavállaló</span>
            <select [(ngModel)]="rog.korabbi" (ngModelChange)="korabbiValaszt($event)"><option [ngValue]="null">– új személy –</option>
              <option *ngFor="let k of korabbiKulsok" [ngValue]="k.adoazonosito">{{ k.nev }} · {{ k.adoazonosito }}</option></select></label>
          <label class="kv-mezo"><span>Név *</span><input type="text" [(ngModel)]="rog.nev" maxlength="120"></label>
          <label class="kv-mezo"><span>Adóazonosító jel *</span><input type="text" [(ngModel)]="rog.adoazonosito" maxlength="10" placeholder="8xxxxxxxxx"></label>
          <label class="kv-mezo"><span>TAJ-szám</span><input type="text" [(ngModel)]="rog.taj" maxlength="11" placeholder="9 számjegy (a bejelentéshez kell)"></label>
        </ng-container>
        <label class="kv-mezo"><span>Jelleg *</span>
          <select [(ngModel)]="rog.tipus"><option *ngFor="let t of d?.tipusok" [ngValue]="t.tipus">{{ t.cim }}</option></select></label>
        <label class="kv-mezo"><span>Első nap *</span><input type="date" [(ngModel)]="rog.tol"></label>
        <label class="kv-mezo"><span>Utolsó nap</span><input type="date" [(ngModel)]="rog.ig" [min]="rog.tol"></label>
        <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="rog.hetvege_nelkul"> Szombat és vasárnap kihagyása</label>
          <label><input type="checkbox" [(ngModel)]="rog.szakkepzett"> Szakképzettséget igénylő munkakör (garantált bérminimum)</label></div>
        <label class="kv-mezo"><span>Napi bér (Ft) *</span><input type="number" min="0" [(ngModel)]="rog.napi_ber"></label>
        <label class="kv-mezo"><span>Napi óraszám</span><input type="number" min="0" max="24" step="0.5" [(ngModel)]="rog.orak"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="rog.megjegyzes" maxlength="255"></label>
        <div class="ho-szamitott">
          <span>Napok: <b>{{ napokSzama(rog) }}</b></span>
          <span>Közteher/nap: <b>{{ ft(napiKozteher(rog.tipus)) }}</b></span>
          <span>Közteher összesen: <b>{{ ft(napiKozteher(rog.tipus) * napokSzama(rog)) }}</b></span>
          <span [class.min]="+rog.napi_ber && +rog.napi_ber < legkisebbBer(rog)">Legkisebb napi bér: {{ ft(legkisebbBer(rog)) }}</span>
        </div>
        <p class="halvany efo-sugo">Egy személy egy napjára egy sor lehet – a már rögzített napok kimaradnak. A mezőgazdasági idénymunka
          {{ param.efo_mg_alap }}. napjától járó magasabb közterhet a lista számolja.</p>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="rogzit()" [disabled]="mentes"><ion-icon name="save-outline"></ion-icon>Rögzítés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══════════════ egy nap módosítása ═══════════════ -->
<ion-modal #napModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi()">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>EFO-nap – {{ nap?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="napModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="nap">
        <app-szerk-zar-sav [zar]="zarNap"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="nap.datum"></label>
        <label class="kv-mezo"><span>Jelleg</span>
          <select [(ngModel)]="nap.tipus"><option *ngFor="let t of d?.tipusok" [ngValue]="t.tipus">{{ t.cim }}</option></select></label>
        <label class="kv-mezo"><span>Napi bér (Ft)</span><input type="number" min="0" [(ngModel)]="nap.napi_ber"></label>
        <label class="kv-mezo"><span>Napi óraszám</span><input type="number" min="0" max="24" step="0.5" [(ngModel)]="nap.orak"></label>
        <div class="nk-kapcs"><label><input type="checkbox" [(ngModel)]="nap.szakkepzett"> Szakképzettséget igénylő munkakör</label></div>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="nap.megjegyzes" maxlength="255"></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="napMent()" [disabled]="mentes || (zarNap && !zarNap.irhato)"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #paramModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Paraméterek – {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="paramModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-ber-juttatas-param [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [csoportok]="['efo', 'kozos']" (mentve)="paramMentve()"></app-ber-juttatas-param>
    </div>
  </ng-template>
</ion-modal>
